// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Role, readParameterFromRouterState, ScopeCategory } from '@app/core';
import { RoleDetailsFacadeService } from '@app/access-management/state/role-details.facade';
import { OrganizationDetailsFacadeService } from '@app/access-management/state/organization-details/organization-details.facade';

@Component({
  selector: 'app-organization-role-users-list',
  templateUrl: './organization-role-users-list.component.html',
  styleUrls: ['./organization-role-users-list.component.scss']
})
export class OrganizationRoleUsersListComponent {
  readonly role$: Observable<Role | undefined>;

  organization$: Observable<ScopeCategory>;
  roleId: string;
  organizationId: string;
  _currentUser$: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private roleDetailsFacadeService: RoleDetailsFacadeService,
    private organizationDetailsFacade: OrganizationDetailsFacadeService
  ) {
    const organizationId = readParameterFromRouterState(this.activatedRoute, 'orgId');
    if (!organizationId) {
      throw new Error('organization id not in route');
    }
    this.organizationId = organizationId;
    const roleId = readParameterFromRouterState(this.activatedRoute, 'id');
    if (!roleId) {
      throw new Error('role id not in route');
    }
    this.roleId = roleId;
    this.roleDetailsFacadeService.initializeOrgRoles(this.organizationId, this.roleId);
    this.role$ = this.roleDetailsFacadeService.role$;
    this.organizationDetailsFacade.initialize(this.organizationId);
    this.organization$ = this.organizationDetailsFacade.organization$;
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/organizations/organization-role-users-list/organization-role-users-list.component.ts